import { HTTP_INTERCEPTORS as Provide } from '@angular/common/http';
import { Provider } from '@angular/core';
import { AuthenticationInterceptor as Value } from '@daas-consulting/security/authentication/frontend/utils';

export const AuthenticationInterceptorProvider: Provider = {
  provide: Provide,
  useClass: Value,
  multi: true,
};
